<script>

    import { toast } from 'bulma-toast'
    import { prepaidsStore, modalStore } from '../stores'

    import PrepaidsService from '../$services/prepaids.service.js'
    import DateMethod from '../$methods/date.method.js'

    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    let loading = false

    getPrepaids()

    async function getPrepaids() {

        loading = true
        const resp = await PrepaidsService.getPrepaids(null, 'global')
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        prepaidsStore.set(resp.data)
    }

</script>

<Table items={$prepaidsStore.length} {loading}>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column is-narrow ml-auto">
                <div>
                    <ButtonModal modalId="prepaid_create_modal" icon="plus" text="Crear" />
                </div>
            </div>
        </div>
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Estatus</th>
            <th>Proveedor</th>
            <th>Servicio</th>
            <th>Peso</th>
            <th class="has-text-right">Total</th>
            <th class="has-text-right">Usadas</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $prepaidsStore as prepaid, index}
            <tr>
                <td>{index + 1}</td>
                <td>{prepaid.shipments.length < prepaid.shipmentsTotal && DateMethod.isAfter(prepaid.expired) ? 'Activo' : 'Expiró'}</td>
                <td>{prepaid.provider}</td>
                <td>{prepaid.service}</td>
                <td>{prepaid.volumetricMax} kg</td>
                <td class="has-text-right">{prepaid.shipmentsTotal}</td>
                <td class="has-text-right">{prepaid.shipments.length}</td>
                <td>
                    <Button on:click={() => modalStore.open('prepaid', 'modal', prepaid)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>